var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-actions"},[_c('CartTotal'),_c('button',{staticClass:"bottom-btn",on:{"click":_vm.checkout}},[_vm._v("Checkout")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }